import React from 'react';
import { TypedMemo } from '../common/types';
import { Panel } from '../music24/components/primitives/Panel';
import styles from './TeamAcceptCard.module.scss';

/**
 * The accept page's one card (designs f and q). Every state renders inside it. Each state draws its
 * own centred heading (TeamAcceptHeading), so this box has no head row.
 */
const TeamAcceptCardComponent: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Panel className={styles.card}>
    <div className="p-4">{children}</div>
  </Panel>
);

export const TeamAcceptCard = TypedMemo(TeamAcceptCardComponent);
